import { render } from "./researchLinkList.vue?vue&type=template&id=0197d9aa"
import script from "./researchLinkList.vue?vue&type=script&lang=js"
export * from "./researchLinkList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__